import React from 'react';
import { string, func } from 'prop-types';
import Filters from '../../../../components/sections/Resume/Filters';

const AuditFilters = ({ currentValue, onSubmitFilters }) => {
    return (<Filters
        exclude={['slas', 'status']}
        currentValue={currentValue}
        onSubmitFilters={onSubmitFilters}
        isAuditMonitor
    />);
};

AuditFilters.propTypes = {
    currentValue: string,
    onSubmitFilters: func.isRequired
};

export default AuditFilters;